import { render } from "./AttributionPage.vue?vue&type=template&id=8dd3e046&scoped=true"
import script from "./AttributionPage.vue?vue&type=script&lang=js"
export * from "./AttributionPage.vue?vue&type=script&lang=js"

import "./AttributionPage.vue?vue&type=style&index=0&id=8dd3e046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dd3e046"]])

export default __exports__